import { useEffect, useState } from "react";
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { useSpinner } from '../../customHooks';
import {getMobileLicenseUsersList, selector as getMobileLicenseUsersApi} from "./getMobileLicenseUsersSlice";
import { manageMobileLicenseUsers, selector as manageMobileLicenseUsersApi } from './manageMobileLicenseUsersSlice';
import { getCookie, isDirectAdmin, isSuccessResponse } from '../../common/utils';
import useNotification from '../notification/useNotification';
import {Status} from "../../common/constants";

export const useMobileLicensing = (users, licenseDetails) => {
    const [show, setShow] = useState(false);
    const [filteredMobileLicenseUsers, setFilteredMobileLicenseUsers] = useState([]);
    const [toggleStates, setToggleStates] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const { showSuccessNotification, showWarningNotification } = useNotification();
    const dispatch: ThunkDispatch<any, undefined, Action> = useDispatch();
    const getMobileLicenseUsersResponse: any = useSelector(getMobileLicenseUsersApi);
    const manageMobileLicenseUsersResponse: any = useSelector(manageMobileLicenseUsersApi);
    useSpinner(manageMobileLicenseUsersResponse.status);
    useSpinner(getMobileLicenseUsersResponse.status);
    {(isDirectAdmin() && licenseDetails.isActive )&& useEffect(() => {
        dispatch(getMobileLicenseUsersList());
      }, []);}

    useEffect(() => {
        if (getMobileLicenseUsersResponse.status === Status.SUCCESS && users?.length > 0) {
            setFilteredMobileLicenseUsers(getMobileLicenseUsersResponse.users?.data);
        }
    }, [getMobileLicenseUsersResponse, users]);


    useEffect(() => {
        setToggleStates(getSavedToggleStates());
      }, [users, filteredMobileLicenseUsers]);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setSearchTerm("");
        setToggleStates(getSavedToggleStates());
        setShow(false);
    };

    const handleToggle = (email) => {
        setToggleStates(prev =>
          prev.map(item =>
            item.email === email ? { ...item, enabled: !item.enabled } : item
          )
        );
    };

    const getSavedToggleStates = () => {
      if (!users || !Array.isArray(users)) return [];

      const filteredUsers = users.filter(
        (user) => user.status !== "Invited"
      );

      const licensedUserIds = new Set(
        filteredMobileLicenseUsers.map((licensedUser) => licensedUser.userId)
      );

      return filteredUsers.map((user) => ({
        email: user.email,
        enabled: licensedUserIds.has(user.userId),
      }));
    };

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const selectedUserIds = toggleStates
          .filter(u => u.enabled)
          .map(u => {
            const user = users.find(user => user.email === u.email);
            return user?.userId;
          })
          .filter(Boolean);
        const orgId = getCookie('organizationId') || '';
        const payload = {
          userIds: selectedUserIds,
          orgId,
        };

        try {
          const manageMobileLicenseUsersResponse = await dispatch(manageMobileLicenseUsers(payload)).unwrap();
          await dispatch(getMobileLicenseUsersList(orgId)).unwrap();
          showSuccessNotification(manageMobileLicenseUsersResponse.message.split('for')[0]);
          handleClose();
        } catch (err) {
           showWarningNotification('Failed to update mobile licenses.');
        }
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const sanitizedSearchValue = event.target.value.replace(/\s/g, "");
      setSearchTerm(sanitizedSearchValue);
    };

    const handleSearchKeyDown = (
        event: React.KeyboardEvent<HTMLInputElement>
      ) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
        }
    };

    return {
        show,
        handleShow,
        handleClose,
        filteredMobileLicenseUsers,
        toggleStates,
        setToggleStates,
        handleToggle,
        onSubmit,
        searchTerm,
        setSearchTerm,
        handleSearchChange,
        handleSearchKeyDown
    }
};